import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Home from "@/pages/Home";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import PaymentSuccess from "@/pages/PaymentSuccess";
import UberMich from "@/pages/UberMich";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Methodik from "@/pages/Methodik";
import DornBreuss from "@/pages/DornBreuss";
import Programme from "@/pages/Programme";
import Analyse from "@/pages/Analyse";
import Kennenlerngespraech from "@/pages/Kennenlerngespraech";
import AGB from "@/pages/AGB";
import StickyWhatsApp from "@/components/StickyWhatsApp";

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/ueber-mich" element={<UberMich />} />
                        <Route path="/uber-mich" element={<Navigate to="/ueber-mich" replace />} />
                        <Route path="/methodik" element={<Methodik />} />
                        <Route path="/dorn-breuss" element={<DornBreuss />} />
                        <Route path="/programme" element={<Programme />} />
                        <Route path="/analyse" element={<Analyse />} />
                        <Route path="/kennenlerngespraech" element={<Kennenlerngespraech />} />
                        <Route path="/journal" element={<Blog />} />
                        <Route path="/journal/:slug" element={<BlogPost />} />
                        <Route path="/blog" element={<Navigate to="/journal" replace />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/impressum" element={<Impressum />} />
                        <Route path="/datenschutz" element={<Datenschutz />} />
                        <Route path="/agb" element={<AGB />} />
                        <Route path="/success" element={<PaymentSuccess />} />
                    </Routes>
                    <StickyWhatsApp />
                    <Toaster
                        position="top-center"
                        richColors
                        closeButton
                        toastOptions={{
                            style: {
                                fontFamily: "Outfit, sans-serif",
                                borderRadius: "16px",
                            },
                        }}
                    />
                </BrowserRouter>
            </LanguageProvider>
        </div>
    );
}

export default App;
